export default "__VITE_ASSET__BrUGq_3a__"